import React from 'react';
import ClientInvoiceItemFields, {
    formValueToInvoiceItem,
    newEntryFormValue,
} from '../../../../../../../shared/ClientInvoiceItems/ClientInvoiceItemFields';
import useOrganizationClientRecordInvoiceItems from '../../../../../../../../hooks/api/useOrganizationClientRecordInvoiceItems';
import { AnimateLoadedContent } from '../../../../../../../v2BaseComponents/Loader';
import { Form } from '../../../../../../../v2BaseComponents/Form';
import { getIntl } from '../../../../../../../../utils/intl';
import SideDrawerFormContainer from '../../../../../../../v2BaseComponents/Form/SideDrawerFormContainer';

const intl = getIntl('profiles.clientInvoiceItems.add', {
    create: 'Create',
});

export type AddInvoiceItemContentOwnProps = {
    onCreateInvoiceItem: () => void;
    onCancel: () => void;
    clientRecordId: string;
};

export type AddInvoiceItemContentProps = AddInvoiceItemContentOwnProps;

const AddInvoiceItemContent: React.FC<AddInvoiceItemContentProps> = ({
    clientRecordId,
    onCreateInvoiceItem,
    onCancel,
}) => {
    const { isCreatingInvoiceItem, createInvoiceItem } = useOrganizationClientRecordInvoiceItems({
        clientRecordId,
        onCreateInvoiceItem: onCreateInvoiceItem,
    });

    return (
        <AnimateLoadedContent isLoading={isCreatingInvoiceItem}>
            {() => (
                <Form
                    fillContainer
                    initialValues={newEntryFormValue!}
                    onSubmit={(values) => {
                        const invoiceItem = formValueToInvoiceItem(values);
                        createInvoiceItem({
                            invoiceItems: [invoiceItem],
                        });
                    }}
                    isDisabled={isCreatingInvoiceItem}
                    forceStackFields
                >
                    {({ isSubmitting, handleSubmit, values }) => {
                        return (
                            <SideDrawerFormContainer
                                isDisabled={isSubmitting || isCreatingInvoiceItem}
                                onSubmit={handleSubmit}
                                onCancel={onCancel}
                                saveText={intl('create')}
                                saveIcon="CheckCircle"
                            >
                                <ClientInvoiceItemFields values={values} />
                            </SideDrawerFormContainer>
                        );
                    }}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AddInvoiceItemContent);
